import { Link } from 'react-router-dom';

export default function CurrencySyncResult({ result }) {
    const data = result?.response?.data;
    if (!data || result.status === 'running') return null;
    return <div className="command-currency-results" role="region" aria-label="Currency sync results">
        <dl>{[['created', 'Currencies added'], ['refreshed', 'Rates refreshed'], ['skipped', 'Rates skipped']].map(([key, label]) =>
            <div key={key}><dt>{label}</dt><dd>{data[key] ?? 0}</dd></div>)}</dl>
        {!!data.warnings?.length && <ul>{Array.from(new Set(data.warnings)).map((warning) => <li key={warning}>{warning}</li>)}</ul>}
        <Link to="/admin/currencies">Manage currencies</Link>
    </div>;
}
